<template>
  <div class="backlog-wrapper-outside">
  <div class="backlog-wrapper" :style="small_width?`width: 70px`:''">
    <div
      :style="`
        ${header_sticky_position?`position: sticky; top: ${header_sticky_position};`:''}
        ${header_z_index?`z-index: ${header_z_index};`:''}
        ${color?`background-color: ${color};`:''}
        `"
      :class="`backlog-wrapper-header ${color?color:''}`"
      >
      <v-icon v-if="icon" class="ml-1 mr-1">{{icon}}</v-icon>
      <!-- a div with display flex and space between and     align-items: center; -->
      <div v-if="type === 'backlogsheader'" style="display: flex; flex-grow: 1; justify-content: space-between; align-items: center; ">
        <TText
          :text="!small_width?text:'BL'"
          large
          font_weight="400"
        />
        <slot name="actions" />
      </div>
      <template v-if="!small_width && type !== 'backlogsheader'">
      <TText
        v-if="type === 'wbgroups'"
        :editable="isEditMode"
        :text="text"
        large
        font_weight="300"
        @changeValue="$emit('changeValue', $event)"
        />
      <TText
        v-else
        :editable="isEditMode"
        :text="text"
        medium
        font_weight="300"
        @changeValue="$emit('changeValue', $event)"
        />
      </template>
      <div class="backlog-wrapper-btns" v-if="!small_width">
        
        <TIconButton tooltip="Create" @clickIcon="isEditMode ? $emit('clickAdd') : ''"  icon="sign-plus" :disabled="!isEditMode" />
        <TIconButton tooltip="Delete" v-if="type !== 'backlogsheader'" @clickIcon="isEditMode ? $emit('clickDelete') : ''"  icon="bin-delete" :disabled="!isEditMode" />

      </div>
    </div>
    <slot/>
  </div>
  <slot name="right"/>
  </div>
</template>
<script>
  import TText from '@/components/Taktify/TText.component.vue';
  import TIconButton from '@/components/Taktify/TIconButton.component.vue';
  export default {
    props: ['color', 'isEditMode', 'type', 'text', 'header_sticky_position', 'header_z_index', 'icon', 'small_width'],
    components: {
      TText,
      TIconButton,
    },
    data: () => ({
    }),
  }
</script>
<style>
  .backlog-wrapper-outside {
    display: flex;
  }
  .backlog-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 330px;
    transition: all 0.2s ease-out;
  }
  .backlog-wrapper-header {
    position: relative;
    display: flex;
    height: 50px;
    align-items: center;
    padding: 3px;
    border-top: white solid 1px;
    border-bottom: white solid 1px;
    border-right: white solid 1px;
    /* background-color: #616161; */
  }
  /* .backlog-wrapper-header:hover .backlog-wrapper-btns {
    display: flex
  } */
  .backlog-wrapper-btns{
    position: absolute;
    right: 3px;
    display: flex;
  }
</style>
